export const ORG_ACCESS_ERROR_CODES = {
    FORBIDDEN: "FORBIDDEN",
    NOT_FOUND: "NOT_FOUND",
    INVALID_STATE: "INVALID_STATE",
    ALREADY_CLAIMED: "ALREADY_CLAIMED",
    EMAIL_IN_USE: "EMAIL_IN_USE",
    LAST_ADMIN: "LAST_ADMIN",
    WEAK_PASSWORD: "WEAK_PASSWORD",
    INVALID_CREDENTIALS: "INVALID_CREDENTIALS",
    EMAIL_DELIVERY_FAILED: "EMAIL_DELIVERY_FAILED",
    CONSOLE_URL_UNAVAILABLE: "CONSOLE_URL_UNAVAILABLE",
    RATE_LIMITED: "RATE_LIMITED"
} as const;

export type OrgAccessErrorCode = (typeof ORG_ACCESS_ERROR_CODES)[keyof typeof ORG_ACCESS_ERROR_CODES];

export interface OrgAccessErrorResponse {
    error: string;
    code: OrgAccessErrorCode;
}

export interface ClaimLinkResponse {
    claimUrl: string;
    delivery: ClaimLinkDelivery;
}

/** Console operations expose the URL and state whether an email was also accepted. */
export type ClaimLinkDelivery = "email_and_url" | "url";

export type AdminClaimLinkDelivery = "email" | "url";

export function isOrgAccessErrorCode(value: unknown): value is OrgAccessErrorCode {
    return Object.values(ORG_ACCESS_ERROR_CODES).some((code) => code === value);
}
